module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Access")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Where our users are coming from.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "pad box-pane-right bg-green",
    staticStyle: {
      "min-height": "400px"
    }
  }, _vm._l((_vm.stats), function(stat) {
    return _c('div', {
      staticClass: "description-block margin-bottom"
    }, [_vm._m(2, true), _vm._v(" "), _c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(stat.header))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(stat.text))])])
  }))])])])]), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.css"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Visitors Report")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "id": "world-map-markers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "data-color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-3x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6c5cec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Access.vue
// module id = 1555
// module chunks = 1